import { useMemo } from "react";
import { CalendarEvent, CalendarEventsByTimePeriod } from "./App";

export function useEventsGroupedByPeriod(
	events: CalendarEvent[],
	periodGrouper: (c: Date) => string,
) {
	const groupedEvents = useMemo(() => {
		let months: CalendarEventsByTimePeriod[] = [];
		let lastPeriod = "-";
		for (const e of events) {
			if (e.start?.dateTime && e.end?.dateTime) {
				const d = new Date(e.start.dateTime);
				const monthAndYear = periodGrouper(d);
				if (lastPeriod !== monthAndYear) {
					lastPeriod = monthAndYear;
					months.push({
						periodName: monthAndYear,
						events: [],
						time: 0,
					});
				}
				const startTime = new Date(e.start.dateTime).getTime();
				const endTime = new Date(e.end.dateTime).getTime();
				months[months.length - 1].events.push(e);
				months[months.length - 1].time += endTime - startTime;
			}
		}
		return months;
	}, [events]);
	return groupedEvents;
}
